export default "__VITE_ASSET__DHZKV6ki__"